import zoid from 'zoid9078'
import { hashCode } from '../utils/hashing'

export default class FrameFactory {
  constructor () {
    this.frameComponents = {}
    // Setup frames used by the 2-step experience loading process. These can be
    // removed once that approach has been completely deprecated.
    this.getFrame()
    this.getFrame('small')
    this.getFrame('story')
    this.getFrame('full')
  }

  getFrame (variant = 'embed', url = null) {
    console.debug('APP:frame', variant, url)

    let key = variant
    if (url != null) {
      key = `${variant}-${hashCode(url)}`
    } else {
      url = `${window.provenance.rootUrl}/x`
    }

    if (this.frameComponents[key]) {
      console.debug('found cached frame')
      return this.frameComponents[key]
    }

    let height = '100%'
    let autoResizeHeight = true

    switch (variant) {
      case 'small':
        height = '482px'
        break
      case 'story':
        break
      case 'full':
        autoResizeHeight = false
        break
    }

    const component = zoid.create({
      tag: `provenance-experience-${key}`,
      url,
      dimensions: {
        height,
        width: '100%'
      },
      autoResize: {
        height: autoResizeHeight,
        width: false
      },
      props: {
        url: {
          type: 'string',
          required: true
        },
        version: {
          type: 'string',
          required: false
        },
        openModal: {
          type: 'function',
          required: false
        }
      }
    })

    this.frameComponents[key] = {
      component,
      class: `ProvenanceModal--${variant}Variant`
    }
    return this.frameComponents[key]
  }
}
